import getContractActionsList, {
  downloadContractActionsExport
} from 'src/services/contractActionsService';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import getOptionsFromState from 'src/utils/balanceUtils';
import { selectContractActionsQueryOptions } from '../selectors/contractActionsSelectors';
import { showMessage } from './snackBarActions';

export const LOAD_CONTRACT_ACTIONS = asyncActionCreator(
  'LOAD_CONTRACT_ACTIONS'
);
export const DOWNLOAD_CONTRACT_ACTIONS_EXPORT = asyncActionCreator(
  'DOWNLOAD_CONTRACT_ACTIONS_EXPORT'
);
export const CLEAR_CONTRACT_ACTIONS = 'CLEAR_CONTRACT_ACTIONS';
export const SAVE_CONTRACT_ACTIONS_OPTIONS = 'SAVE_CONTRACT_ACTIONS_OPTIONS';

export const loadContractActions = options => async (dispatch, getState) => {
  try {
    dispatch({ type: LOAD_CONTRACT_ACTIONS.start });

    dispatch({
      type: SAVE_CONTRACT_ACTIONS_OPTIONS,
      options
    });

    const reqOptions = getOptionsFromState(
      selectContractActionsQueryOptions,
      getState
    );

    const contractActions = await getContractActionsList(reqOptions);

    return dispatch({
      type: LOAD_CONTRACT_ACTIONS.success,
      ...contractActions
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: LOAD_CONTRACT_ACTIONS.failure });
  }
};

export const downloadExcelContractActions = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: DOWNLOAD_CONTRACT_ACTIONS_EXPORT.start });

    if (options) {
      dispatch({ type: SAVE_CONTRACT_ACTIONS_OPTIONS, options });
    }

    const reqOptions = getOptionsFromState(
      selectContractActionsQueryOptions,
      getState,
      false
    );

    await downloadContractActionsExport(reqOptions);

    return dispatch({ type: DOWNLOAD_CONTRACT_ACTIONS_EXPORT.success });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: DOWNLOAD_CONTRACT_ACTIONS_EXPORT.failure });
  }
};
